import { render, staticRenderFns } from "./ActionButtons.vue?vue&type=template&id=63535bd4&scoped=true&"
import script from "./ActionButtons.vue?vue&type=script&lang=js&"
export * from "./ActionButtons.vue?vue&type=script&lang=js&"
import style0 from "./ActionButtons.vue?vue&type=style&index=0&id=63535bd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63535bd4",
  null
  
)

export default component.exports